import React from 'react';
import RightArrow from '@/components/Icons/icons/RightArrow';
import { timeAgo } from '@/utils/ts/stringUtils';
import { useSelector } from 'react-redux';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

export default function BasicNotification({
  notification,
  fallbackTitle = '',
  actionLabel,
  onActionClick,
}) {
  const { userProfile } = useSelector((state) => state.user);

  return (
    <div className={`single-notification ${notification?.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={userProfile?.profile_link}
          alt={userProfile?.first_name + ' ' + userProfile?.last_name || ''}
        />
      </div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">{notification?.title || fallbackTitle}</h3>
        <p className="description">{notification?.description}</p>
        {actionLabel && onActionClick && (
          <div className="mt-2">
            <ButtonComponent
              variant="text-highlight"
              className="p-0"
              onClick={onActionClick}
              rightIcon={<RightArrow color="var(--text-highlight)" />}>
              <span className="text-sm">{actionLabel}</span>
            </ButtonComponent>
          </div>
        )}
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
